import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getLimitKPI = ({ limitConfig }) => {
    return limitConfig.limitKPI || [];
};

const getTimeSeriesList = ({ limitConfig }) => {
    return limitConfig.timeSeries || [];
};

const getCurrentTimeseries = ({ limitConfig }) => {
    return limitConfig.currentTimeSeries || [];
};

const getShowSuggestLimitModal = ({ limitConfig }) => {
    return limitConfig.showSuggestLimitModal;
};

const getSelectedTimeSeriesForSuggestion = ({ limitConfig }) => {
    return limitConfig.selectedTimeSeriesForSuggestion;
};

const getSelectedTimeSeriesSuggestionData = ({ limitConfig }) => {
    return limitConfig.suggestedLimit;
};

const getSelectedTrendKPIs = ({ operationalParameters }) => {
    return operationalParameters?.preselectedKPIs?.single?.trend;
};

const getClickedKpiConfig = ({ operationalParameters }) => {
    return operationalParameters?.clickedKpiConfig;
};

const getExpandedSignals = ({ limitConfig }) => {
    return limitConfig.expandedSignals;
};

const getDefaultLimts = ({ limitConfig }) => {
    return limitConfig?.defaultLimit?.data;
};

const getDefaultLimtsLoading = ({ limitConfig }) => {
    return limitConfig?.defaultLimit?.isLoading;
};

const getOffsetModalId = ({ limitConfig }) => {
    return limitConfig?.offsetModalId;
};

const getLimitKPIError = ({ limitConfig }) => {
    return {
        loadingStatus: limitConfig?.limitKPI?.isLoading,
        errorCode: limitConfig?.limitKPI?.statusCode,
        error: limitConfig?.limitKPI?.error
    };
};

const getTimeseriesError = ({ limitConfig }) => {
    return {
        loadingStatus: limitConfig?.timeSeries?.isLoading,
        errorCode: limitConfig?.timeSeries?.statusCode,
        error: limitConfig?.timeSeries?.error,
        suppressGlobalNotification: limitConfig?.timeSeries?.suppressGlobalNotification
    };
};

const getSuggestedLimitsError = ({ limitConfig }) => {
    return {
        loadingStatus: limitConfig?.suggestedLimit?.isLoading,
        errorCode: limitConfig?.suggestedLimit?.statusCode,
        error: limitConfig?.suggestedLimit?.error
    };
};

const getDefaultLimitsError = ({ limitConfig }) => {
    return {
        loadingStatus: limitConfig?.defaultLimit?.isLoading,
        errorCode: limitConfig?.defaultLimit?.statusCode,
        error: limitConfig?.defaultLimit?.error
    };
};

// Memoized selector for default limits error data
const getDefaultLimitsErrorData = createErrorDataSelector(getDefaultLimitsError);

// Memoized selector for suggested limits error data
const getSuggestedLimitsErrorData = createErrorDataSelector(getSuggestedLimitsError);

// Memoized selector for timeseries error data
const getTimeseriesErrorData = createErrorDataSelector(getTimeseriesError);

// Memoized selector for limit KPI error data
const getLimitKPIErrorData = createErrorDataSelector(getLimitKPIError);

export const getModel = createSelector([
    getLimitKPI,
    getCurrentTimeseries,
    getTimeSeriesList,
    getShowSuggestLimitModal,
    getSelectedTimeSeriesForSuggestion,
    getSelectedTimeSeriesSuggestionData,
    getSelectedTrendKPIs,
    getClickedKpiConfig,
    getExpandedSignals,
    getDefaultLimts,
    getDefaultLimtsLoading,
    getOffsetModalId,
    getLimitKPIErrorData,
    getTimeseriesErrorData,
    getSuggestedLimitsErrorData,
    getDefaultLimitsErrorData
], (
    limitKPI,
    currentTimeSeries,
    timeSeries,
    showSuggestLimitModal,
    selectedTimeSeriesForSuggestion,
    suggestedLimit,
    selectedTrendKPIs,
    clickedKpiConfig,
    expandedSignals,
    defaultLimits,
    defaultLimtsLoading,
    offsetModalId,
    limitKPIErrorData,
    timeseriesErrorData,
    suggestedLimitsErrorData,
    defaultLimitsErrorData
) => {
    return {
        limitKPI,
        currentTimeSeries,
        timeSeries,
        showSuggestLimitModal,
        selectedTimeSeriesForSuggestion,
        suggestedLimit,
        selectedTrendKPIs,
        clickedKpiConfig,
        expandedSignals,
        defaultLimits,
        defaultLimtsLoading,
        offsetModalId,
        limitKPIErrorData,
        timeseriesErrorData,
        suggestedLimitsErrorData,
        defaultLimitsErrorData
    };
});
